import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4","key":"svg-0"}],["path",{"d":"M4 18v-12h3a3 3 0 1 1 0 6h-3c5.5 0 5 4 6 6","key":"svg-1"}],["path",{"d":"M18 6v-2","key":"svg-2"}],["path",{"d":"M17 20v-2","key":"svg-3"}]]

const IconCurrencyReal = createReactComponent('outline', 'currency-real', 'CurrencyReal', __iconNode);

export default IconCurrencyReal;